var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"iframe-wrapper"}},[_c('object',{style:(_vm.iframe.style),attrs:{"height":_vm.iframe.style.height,"width":_vm.iframe.style.width,"data":_vm.iframe.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }